//Responsive Loading Spinner, used in Individual Widget, when they are loading.
import React from 'react';
import { AppSetting } from '../common/function';

const SecureShow = function(props) {
  // let universityPrefix = GetPrefixUniversity();
  // const AppSetting = JSON.parse(window.localStorage.getItem(`${universityPrefix}_CpanelAppsettings`));
  const AppSettings = AppSetting();
  const enableLogin = AppSettings.REACT_APP_ENABLE_LOGIN;

  let tempUserProfile = {};
  tempUserProfile.givenName = window.localStorage.getItem(`${AppSettings.REACT_APP_UNIVERSITY_SUFFIX}_GivenName`);
  tempUserProfile.unixEpoch = window.localStorage.getItem(`${AppSettings.REACT_APP_UNIVERSITY_SUFFIX}_UnixEpoch`);
  tempUserProfile.emailid = window.localStorage.getItem(`${AppSettings.REACT_APP_UNIVERSITY_SUFFIX}_emailid`);
  tempUserProfile.OSUID = window.localStorage.getItem(`${AppSettings.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`);
  tempUserProfile.role = parseInt(window.localStorage.getItem(`${AppSettings.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10);

  // tempUserProfile.role - role refers to role_weight
  if (tempUserProfile.role >= props.targetRole || enableLogin !== true) {
    return props.children;
  } else {
    if (props.noAccessHTML !== null && props.noAccessHTML !== undefined) {
      return props.noAccessHTML;
    } else {
      return <span />;
    }
  }
};

export default SecureShow;
